import { render, staticRenderFns } from "./SkuItemWelfare.vue?vue&type=template&id=32d5940a&scoped=true"
import script from "./SkuItemWelfare.vue?vue&type=script&lang=js"
export * from "./SkuItemWelfare.vue?vue&type=script&lang=js"
import style0 from "./SkuItemWelfare.vue?vue&type=style&index=0&id=32d5940a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5940a",
  null
  
)

export default component.exports